import cx from 'clsx';
import { amplitudeLogger } from 'common/amplitude';
import { AMPLITUDE_ATTRIBUTE_KEYS, MESSENGER_EVENTS } from 'common/enums/amplitudeEvents';
import { FC, MouseEventHandler } from 'react';

import { ReactComponent as CrossIcon } from './icons/cross.min.svg';
import { ReactComponent as SwapIcon } from './icons/swap.min.svg';
import styles from './OverlayContainer.module.less';
import { ESide } from './OverlayContainerContext.types';

interface IProps {
  onClose: () => void;
  onToggleSide?: () => void;
  side?: ESide;
  isMobile: boolean;
}

export const HeaderControls: FC<IProps> = ({ onClose, onToggleSide, isMobile, side }) => {
  const handleCloseClick: MouseEventHandler<SVGSVGElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();

    amplitudeLogger(MESSENGER_EVENTS.MESSENGER_CLOSED);
    onClose();
  };

  const handleToggleSideClick: MouseEventHandler<SVGSVGElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (side) {
      amplitudeLogger(MESSENGER_EVENTS.MESSENGER_SIDE_SWAPPED, {
        [AMPLITUDE_ATTRIBUTE_KEYS.SIDE]: side,
      });
    }

    onToggleSide?.();
  };

  return (
    <div
      className={cx({
        [styles.headerControlsBlock]: true,
      })}
    >
      {!isMobile && onToggleSide ? <SwapIcon onClick={handleToggleSideClick} /> : null}
      <CrossIcon onClick={handleCloseClick} />
    </div>
  );
};
